<ul [ngClass]="{ expanded: expanded() }" class="sub-list">
  @for (subItem of subItems(); track i; let i = $index) {
    @if (isVisible(subItem.visible)) {
      <li class="sub-list__item">
        <a [routerLinkActive]="['active']" [routerLink]="subItem.url">
          <span>{{ subItem.header | translate }}</span>
        </a>
      </li>
    }
  }
</ul>
